import { render, staticRenderFns } from "./Blacklists.vue?vue&type=template&id=2a6ae57a"
import script from "./Blacklists.vue?vue&type=script&lang=js"
export * from "./Blacklists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports